// extracted by mini-css-extract-plugin
export var activeFilterButton = "_m9-c";
export var backButton = "_m9-4";
export var backIcon = "_m9-5";
export var chevronShortcut = "_m9-6";
export var container = "_m9-1";
export var editor = "_m9-8";
export var editorWrapper = "_m9-7";
export var prefix = "_m9-2";
export var searchIcon = "_m9-3";
export var suffix = "_m9-9";
export var suffixContent = "_m9-a";
export var suffixText = "_m9-b";
export var wrapper = "_m9-0";